import axios from '../api';

export default {
  namespaced: true,

  state: {
    listModulesPages: [],

    infosPage:{
      id_page: 1,
      libelle_page: '',
      name_page: '',
    },

    neopassDatas:{},

    loading: false,
    messageHeader: '',

  },

  getters: {
    listModulesPages(state){
      return state.listModulesPages;
    },

    infosPage(state){
      return state.infosPage;
    },

    neopassDatas(state){
      return state.neopassDatas;
    },

    loading(state){
      return state.loading;
    },

    messageHeader(state){
      return state.messageHeader;
    },
  },

  mutations: {
    SET_LISTMODULESPAGES(state, modules){
      state.listModulesPages = modules;
    },
    SET_INFOSPAGE(state, infos){
      state.infosPage = infos;
    },
    SET_NEOPASSDATAS(state, datas){
      state.neopassDatas = datas;
    },
    SET_LOADING(state, loadornot){
      state.loading = loadornot;
    },
    SET_MESSAGEHEADER(state, progress){
      state.messageHeader = progress;
    },
  },

  actions: {
    async loadModulesPages(context){
      console.log('wait...loadModulesPages');
      await axios.get('/api/modules/getModulesPages/cartographiesCollectives').then((response) => {
        context.commit('SET_LISTMODULESPAGES', response.data);
      }).catch(error => {
        console.log('ERRRR:: ',error.response.data);
      });
    },

    async update_infos_page(context, page){
      console.log('wait...update_infos_page');
      let page_selected = context.getters.listModulesPages.filter(p => p.name == page)[0];

      let infos = {
        id_page: page_selected.id,
        libelle_page: page_selected.libelle,
        name_page: page_selected.name,
      };

      context.commit('SET_INFOSPAGE', infos);
    },

    async load_datas(context, page){ //extracted datas are defined in NeopassController (method loadAllNeopassDatas)
      console.log('wait...load_datas');

      await axios.get('/api/allDatas/'+page).then((response) => {
        //Load datas for the form
        let datas = response.data;

        context.commit('SET_NEOPASSDATAS', datas);
      }).catch(error => {
        console.log('ERRRR:: ', error.response.data);
      });
    },

    async first_load_page(context){
      await context.dispatch('loadModulesPages');
    },

    async change_page(context, page){
      await context.dispatch('update_infos_page', page);
      await context.dispatch('load_datas', page);
    },
  }
};